(() => {
  if (window.anoAccessorySidebarInitialized) return;
  window.anoAccessorySidebarInitialized = true;

  const init = () => {
    // Keep sections in their editor positions so blocks remain directly editable.
    if (window.Shopify?.designMode) return;
    const main = document.getElementById('MainContent');
    const accessories = main?.querySelector('[data-accessory-sidebar]');
    const content = main?.querySelector('product-info[id^="MainProduct-"] product-component, #ProductGridContainer');
    const contentSection = content?.closest('.shopify-section');
    if (!accessories || !contentSection || contentSection.parentElement !== main) return;

    const placeholder = document.createComment('Accessories original position');
    accessories.before(placeholder);
    const sidebar = document.createElement('aside');
    sidebar.className = `accessory-sidebar color-${accessories.dataset.colorScheme} gradient`;
    sidebar.setAttribute('aria-label', 'Zubehör');
    // Theme widths use rem; account for the configured font scale and a scrollbar.
    const fontScale = parseFloat(getComputedStyle(document.documentElement).fontSize) / 10;
    const minimumWidth = Number(accessories.dataset.sidebarBreakpoint) * fontScale + 20;
    const media = window.matchMedia(`(min-width: ${minimumWidth}px)`);

    const alignSidebar = () => {
      if (!media.matches || !sidebar.isConnected) return;
      // Resolve the grid again because filtering can replace its markup.
      const anchor = contentSection.querySelector('#product-grid') || content;
      const top = `${Math.max(0, anchor.getBoundingClientRect().top - main.getBoundingClientRect().top)}px`;
      if (sidebar.style.getPropertyValue('--accessory-top') !== top) {
        sidebar.style.setProperty('--accessory-top', top);
      }
      // Reserve space only at the end of the page, never between content sections.
      const minimumHeight = `${Math.ceil(sidebar.getBoundingClientRect().bottom - main.getBoundingClientRect().top + parseFloat(getComputedStyle(sidebar).marginBottom))}px`;
      if (main.style.getPropertyValue('--accessory-min-height') !== minimumHeight) {
        main.style.setProperty('--accessory-min-height', minimumHeight);
      }
    };

    const update = () => {
      if (media.matches) {
        if (accessories.parentElement !== sidebar) {
          sidebar.append(accessories);
          contentSection.after(sidebar);
        }
        main.classList.add('has-accessory-sidebar');
        alignSidebar();
      } else {
        placeholder.after(accessories);
        sidebar.remove();
        main.classList.remove('has-accessory-sidebar');
        main.style.removeProperty('--accessory-min-height');
      }
    };
    // The configurator changes height as elements are selected or the viewport changes.
    const resizeObserver = new ResizeObserver(alignSidebar);
    resizeObserver.observe(contentSection);
    resizeObserver.observe(sidebar);
    window.addEventListener('resize', alignSidebar, { passive: true });
    media.addEventListener('change', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
